// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-suffix {
  display: block;
  padding: 0 var(--spacing-small);
  color: var(--color-white-semi-opaque);
  font-size: var(--font-size-smallest);
  line-height: var(--font-size-smallest);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sensor/create-order-dialog/create-order-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,+BAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;AACF","sourcesContent":[".input-suffix {\n  display: block;\n  padding: 0 var(--spacing-small);\n  color: var(--color-white-semi-opaque);\n  font-size: var(--font-size-smallest);\n  line-height: var(--font-size-smallest);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
